import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCar, faCalendar, faFolderOpen, faPersonChalkboard, faMap, faMapLocation, faHome, faInfoCircle, faCaretUp, faCaretDown, faLink, faArrowUpRightFromSquare, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faCalendar as farCalendar, faFolderOpen as farFolderOpen, faMap as farMap, faMapLocation as farMapLocation, faHome as farHome, faInfoCircle as farInfoCircle } from '@fortawesome/free-regular-svg-icons'

const iconStyle = { fontSize: "85px" }

export const BigCalendarIcon = () => <FontAwesomeIcon icon={farCalendar} {...iconStyle} />
export const BigMapIcon = () => <FontAwesomeIcon icon={faMapLocation}        {...iconStyle} />
export const BigChartIcon = () => <FontAwesomeIcon icon={faPersonChalkboard} {...iconStyle} />
export const BigContactIcon = () => <FontAwesomeIcon icon={faEnvelope} {...iconStyle} />
export const BigCarIcon = () => <FontAwesomeIcon icon={faCar} {...iconStyle}/>

export const CalendarIcon = () => <FontAwesomeIcon icon={farCalendar} className='pe-1' fontSize="large" />
export const MapIcon = () => <FontAwesomeIcon icon={faMapLocation} className='pe-1' fontSize="large" />
export const ChartIcon = () => <FontAwesomeIcon icon={faPersonChalkboard} className='pe-1' fontSize="large" />
export const HomeIcon = () => <FontAwesomeIcon icon={faHome} className='pe-1' fontSize="large" />
export const InfoIcon = () => <FontAwesomeIcon icon={faInfoCircle} className='pe-2' fontSize="large" />
export const ContactIcon = () => <FontAwesomeIcon icon={faEnvelope} className='pe-2' fontSize="large" />
export const CarIcon = () => <FontAwesomeIcon icon={faCar} className='pe-1' fontSize="large" />

export const ArrowUp = () => <FontAwesomeIcon icon={faCaretUp} color='#124c7c' className='float-end' />
export const ArrowDown = () => <FontAwesomeIcon icon={faCaretDown} color='#124c7c' className='float-end' />
export const LinkIcon = () => <FontAwesomeIcon icon={faLink} />
export const OpenInTabIcon = () => <FontAwesomeIcon icon={faArrowUpRightFromSquare} className='ms-2' fontSize="small" />

